// Creators routes, so links don't repeat path strings.
export const CREATORS_PATHS = {
	landing: '/ixi-finance/creators',
	onboarding: '/ixi-finance/creators/onboarding',
	terms: '/ixi-finance/creators/terms',
	privacy: '/ixi-finance/creators/privacy',
	/** Signed-in creator dashboard; its tabs are in dashboard/tabs.ts. */
	dashboard: '/ixi-finance/creators/dashboard',
} as const;
